import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { setGuestsCount } from 'shared/actions/dailyrentBookingCalendar';
import { updateDailyrentUrlParameters } from 'shared/containers/BookingCalendarInputContainer/helpers';
import { MAX_GUESTS_COUNT, MIN_GUESTS_COUNT } from 'shared/containers/GuestsInputContainer/constants';
import { useSetNormalizedGuestsCountIntoUrl } from 'shared/containers/GuestsInputContainer/helpers';
import { selectDailyrentBookingCalendarGuestsCount } from 'shared/selectors/dailyrentBookingCalendar';
import { pluralize } from 'shared/utils/pluralize';

import { NumberInputWithButtons } from '../../../packages/NumberInputWithButtons';

export const GuestsInputContainer = () => {
  const dispatch = useDispatch();
  const value = useSelector(selectDailyrentBookingCalendarGuestsCount);

  useSetNormalizedGuestsCountIntoUrl();

  const formatValue = React.useCallback(
    (value: number | undefined) => pluralize(value || MIN_GUESTS_COUNT, ['гость', 'гостя', 'гостей']),
    [],
  );

  const handleChange = React.useCallback((value: number | undefined) => {
    const nextValue = value || MIN_GUESTS_COUNT;
    dispatch(setGuestsCount(nextValue));

    const newUrl = updateDailyrentUrlParameters({
      currentUrl: window.location.href,
      guestsCount: nextValue,
    });

    history.replaceState(undefined, '', newUrl);
  }, []);

  return (
    <NumberInputWithButtons
      value={value}
      valueFormatter={formatValue}
      onChange={handleChange}
      min={MIN_GUESTS_COUNT}
      max={MAX_GUESTS_COUNT}
      size="M"
    />
  );
};
